import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { AbstractControl, ControlContainer, FormArray, FormGroup, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { map, Observable } from "rxjs";
import { DriverList } from "../../../dashboard/models/driver-list";
import { ConsumerProfileService } from "../../../dashboard/profile/services/profile.service";
import { TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { SelectedProfileService } from "../../../shared/services/selected-profile.service";

@Component({
  selector: 'app-trip-driver',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './driver-information.component.html',
  styleUrl: './driver-information.component.scss',
})

export class DriverInformationComponent implements OnInit {
    private postTripRequestFormDir = inject(FormGroupDirective);
    private profileService = inject(ConsumerProfileService);
    private selectedProfileService = inject(SelectedProfileService);
    matcher = new TouchedErrorStateMatcher();
    tripRequestFg!: FormGroup;
    appointmentDatesFr!: FormArray;
    driverList$!: Observable<DriverList[]>;

    ngOnInit(): void {
        this.tripRequestFg = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
        this.appointmentDatesFr = this.tripRequestFg.get("tripAppointments") as FormArray;
        this.loadDriverList();
    }

    loadDriverList() {
        this.driverList$ = this.profileService.getProfileSavedDrivers(this.selectedProfileService.selectedRecipientId()!);
    }

    onEnterDriverManual(event: Event ,index: number) {
        if (index === -1)
        {
            this.tripRequestFg.get('driverMannualEntry')?.setValue(true);
            this.tripRequestFg.get('driverFirstName')?.setValue(null);
            this.tripRequestFg.get('driverLastName')?.setValue(null);
        }
        else {
            this.appointmentDatesFr.at(index).get('driverMannualEntry')?.setValue(true);
            this.appointmentDatesFr.at(index).get('driverFirstName')?.setValue(null);
            this.appointmentDatesFr.at(index).get('driverLastName')?.setValue(null);
        }
    }

    onEnterDriverfromList (event: Event,index: number) {
        event.preventDefault();
        if (index === -1)
        {
            this.tripRequestFg.get('driverMannualEntry')?.setValue(false);
            this.tripRequestFg.get('saveDriverIntoProfile')?.setValue(false);
         }
        else {
            this.appointmentDatesFr.at(index).get('driverMannualEntry')?.setValue(false);
            this.appointmentDatesFr.at(index).get('saveDriverIntoProfile')?.setValue(false);
        }
    }

    hasError(controlName: string, errorName: string): boolean {
        const control: AbstractControl | null = this.tripRequestFg.get(`${controlName}`);
        return !!control && control.hasError(errorName) && (control.dirty || control.touched);
    }

    driverSelectionChange(event: MatSelectChange) {
        this.driverList$.pipe(
         map(items => items.find(item => item.id === event.value)))
            .subscribe(driver => {
                this.tripRequestFg.get('driverFirstName')?.setValue(driver?.firstName);
                this.tripRequestFg.get('driverLastName')?.setValue(driver?.lastName);
            }
        );
    }

    appointmentDriverSelectionChange(event: MatSelectChange, index: number) {
        this.driverList$.pipe(
         map(items => items.find(item => item.id === event.value)))
            .subscribe(driver => {
                this.appointmentDatesFr.at(index).get('driverFirstName')?.setValue(driver?.firstName);
                this.appointmentDatesFr.at(index).get('driverLastName')?.setValue(driver?.lastName);
            }
        );
    }
}
